import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyALBhsfF1mh3adBFner5ES5GuTCPPldz2k",
  authDomain: "ithraa-deom.firebaseapp.com",
  databaseURL: "https://ithraa-deom-default-rtdb.firebaseio.com",
  projectId: "ithraa-deom",
  storageBucket: "ithraa-deom.firebasestorage.app",
  messagingSenderId: "548155921218",
  appId: "1:548155921218:web:69f8eff36355a1132beedb"
};


// Initialize Firebase app (named 'ithraa' to support database override)
export const app = getApps().length > 0 
  ? getApps()[0] 
  : initializeApp(firebaseConfig, 'ithraa');

// Use 'ithraaoperation' Firestore database instead of the default one
export const firestore = getFirestore(app);

// Initialize Firebase Auth
export const auth = getAuth(app);

// Export collection names as constants
export const COLLECTIONS = {
  PILGRIMS: 'Pilgrims',
  PACKAGES: 'Packages',
  GUIDES: 'Guides',
  ACCOMMODATION: 'AccommodationTables'
} as const;
